import React from 'react';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { IoIosWarning } from 'react-icons/io';

type PausePromoterModalProps = {
  onClose: () => void;
};

const PausePromoterModal: React.FC<PausePromoterModalProps> = ({ onClose }) => (
  <Modal
    visible
    autoHeight
    onClose={onClose}
    type={ModalType.SMALL}
    title="Pause Promoter?"
    icon={<IoIosWarning size={20} color="#8B661E" />}
  >
    <div className="flex flex-col mx-4">
      <div className="flex flex-col gap-2 mt-6 text-sm font-normal text-[#575757]">
        This promoter wont earn rewards from new sales, but they will keep what
        they have already earned. You can reactivate their link anytime.
      </div>
      <div className="flex flex-row items-center justify-center gap-2 mt-6">
        <Button type={ButtonType.Inverted}>Cancel</Button>
        <Button type={ButtonType.Primary}>Pause Promoter</Button>
      </div>
    </div>
  </Modal>
);

export default PausePromoterModal;
